var map = {
	"./Appear": "zEWM",
	"./Appear.js": "zEWM",
	"./Box": "oVTX",
	"./Box.js": "oVTX",
	"./Boxes": "A3k8",
	"./Boxes.js": "A3k8",
	"./Communications": "9Hwt",
	"./Communications.js": "9Hwt",
	"./Communications1": "mg/g",
	"./Communications1.js": "mg/g",
	"./Communications2": "tJrH",
	"./Communications2.js": "tJrH",
	"./Communications3": "ppHV",
	"./Communications3.js": "ppHV",
	"./Communications4": "zdye",
	"./Communications4.js": "zdye",
	"./Congres": "XRFv",
	"./Congres.js": "XRFv",
	"./Container": "VUD3",
	"./Container.js": "VUD3",
	"./Cta": "qRgO",
	"./Cta.js": "qRgO",
	"./Faqs": "HC2U",
	"./Faqs.js": "HC2U",
	"./Footer": "JwsL",
	"./Footer.js": "JwsL",
	"./Header": "rY4l",
	"./Header.js": "rY4l",
	"./Image": "5Epl",
	"./Image.js": "5Epl",
	"./Inscriptions": "OJSv",
	"./Inscriptions.js": "OJSv",
	"./Layout": "7oih",
	"./Layout.js": "7oih",
	"./ModuleIterator": "tkU8",
	"./ModuleIterator.js": "tkU8",
	"./Organization": "EUJw",
	"./Organization.js": "EUJw",
	"./Organization1": "7X3Z",
	"./Organization1.js": "7X3Z",
	"./Page": "uVCN",
	"./Page.js": "uVCN",
	"./ProgramItem": "GBBu",
	"./ProgramItem.js": "GBBu",
	"./ProgramItemPoint": "XRGr",
	"./ProgramItemPoint.js": "XRGr",
	"./Programs": "r8Rj",
	"./Programs.js": "r8Rj",
	"./SectionTitle": "Gkw6",
	"./SectionTitle.js": "Gkw6",
	"./Session": "WMzp",
	"./Session.js": "WMzp",
	"./Slide": "Y0u9",
	"./Slide.js": "Y0u9",
	"./Slider": "3tIP",
	"./Slider.js": "3tIP",
	"./Text": "2dMJ",
	"./Text.js": "2dMJ",
	"./Video": "pjWk",
	"./Video.js": "pjWk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GwNf";